import React from 'react'
import twitter from "../../Assets/images/twitter.png";
import facebook from "../../Assets/images/facebook.png";
import pinterest from "../../Assets/images/pinterest.png";
import img1 from "../../Assets/images/img1.png";
import img3 from "../../Assets/images/img3.png";
import img2 from "../../Assets/images/img2.png";
// import img4 from "../../Assets/images/img4.png";
// import img5 from "../../Assets/images/img5.png";
// import img6 from "../../Assets/images/img6.png";

const ContactMap = () => {
    return (
        <>
            <div className="section-full sf-contact-map-area">
                <div className="container">
                    <div className="sf-map-social-block text-center">
                        <h2>Trusted by thousands of people all over the world</h2>
                        <ul className="sf-con-social">
                            <li>
                                <a href="#" className="sf-fb text-decoration-none">
                                    <img src={facebook} alt="" />
                                    Facebook
                                </a>
                            </li>
                            <li>
                                <a href="#" className="sf-twitter text-decoration-none">
                                    <img src={twitter} alt="" />
                                    Twitter
                                </a>
                            </li>
                            <li>
                                <a href="#" className="sf-pinterest text-decoration-none">
                                    <img src={pinterest} alt="" />
                                    Pinterest
                                </a>
                            </li>
                        </ul>
                        <div className="sf-con-social-pic">
                            <span className="img-pos-1">
                                <img src={img1} alt="" />
                            </span>
                            <span className="img-pos-2">
                                <img src={img2} alt="" />
                            </span>
                            <span className="img-pos-3">
                                <img src={img3} alt="" />
                            </span>
                            <span className="img-pos-4">
                                <img src={img1} alt="" />
                            </span>
                            <span className="img-pos-5">
                                <img src={img2} alt="" />
                            </span>
                            <span className="img-pos-6">
                                <img src={img3} alt="" />
                            </span>
                        </div>
                    </div>
                </div>
                <div className="sf-map-wrap">
                    <div className="gmap-area">
                        <iframe src="https://maps.google.com/maps?width=100%25&height=600&hl=en&q=1%20Grafton%20Street,%20Dublin,%20Ireland+(My%20Business%20Name)&t=&z=14&ie=UTF8&iwloc=B&output=embed" />
                    </div>
                </div>
            </div>

        </>
    )
}

export default ContactMap